/**
 * Hell oder dunkel fürs Admin — dieselbe Regel wie in der Besucher-App
 * (apps/web/src/lib/theme.ts, ADR 0011): Das Admin folgt dem System, und
 * wechselt mit, wenn das System umschaltet. Der Schalter legt eine eigene
 * Wahl fest, die in diesem Browser vor dem System gilt. index.html wendet
 * dieselbe Regel vor dem ersten Zeichnen an.
 */
export type Theme = 'dark' | 'light'

export const STORAGE_KEY = 'k4ia_admin_theme'

const SYSTEM_QUERY = '(prefers-color-scheme: dark)'

export function storedTheme(): Theme | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored === 'light' || stored === 'dark' ? stored : null
  } catch {
    return null
  }
}

export function systemTheme(): Theme {
  try {
    return window.matchMedia(SYSTEM_QUERY).matches ? 'dark' : 'light'
  } catch {
    return 'dark'
  }
}

export function readTheme(): Theme {
  return storedTheme() ?? systemTheme()
}

export function applyTheme(theme: Theme, merken = true): void {
  document.documentElement.dataset.theme = theme
  if (!merken) return
  try {
    localStorage.setItem(STORAGE_KEY, theme)
  } catch {
    // Not persisted — the switch still works for this page view.
  }
}

/** Folgt dem System, solange keine eigene Wahl gespeichert ist. Gibt das Abmelden zurück. */
export function followSystemTheme(onChange?: (theme: Theme) => void): () => void {
  applyTheme(readTheme(), false)
  let media: MediaQueryList | null = null
  try {
    media = window.matchMedia(SYSTEM_QUERY)
  } catch {
    return () => {}
  }
  const listener = () => {
    if (storedTheme()) return
    const theme = systemTheme()
    applyTheme(theme, false)
    onChange?.(theme)
  }
  media.addEventListener?.('change', listener)
  return () => media?.removeEventListener?.('change', listener)
}
